import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "lib-flexible/flexible.js";
// 加载瀑布流插件
import waterfall from "vue-waterfall2";
Vue.use(waterfall);

// 加载高德地图
import VueAMap from "vue-amap";
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: "bd53dd170087096bccc659ebdd1f6316",
  plugin: [
    "AMap.Scale",
    "AMap.OverView",
    "AMap.ToolBar",
    "AMap.MapType",
    "AMap.PlaceSearch",
    "AMap.Geolocation",
    "AMap.Geocoder",
  ],
  v: "1.4.4",
  uiVersion: "1.0",
});

// vant
import {
  Button,
  Lazyload,
  Overlay,
  Form,
  Field,
  Picker,
  Uploader,
  Loading,
  Toast,
  Dialog,
  Image,
  Popup,
  ActionSheet,
  PullRefresh,
  List,
  Cell,
  Tab,
  Tabs,
  Search,
  Icon,
  DatetimePicker,
  Calendar,
  Switch,
  CheckboxGroup,
  Checkbox,
  RadioGroup,
  Radio,
} from "vant";
Vue.use(Button);
Vue.use(Lazyload, {
  lazyComponent: true,
});
Vue.use(Overlay);
Vue.use(Form);
Vue.use(Field);
Vue.use(Picker);
Vue.use(Uploader);
Vue.use(Loading);
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Image);
Vue.use(Popup);
Vue.use(ActionSheet);
Vue.use(PullRefresh);
Vue.use(List);
Vue.use(Cell);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Search);
Vue.use(Icon);
Vue.use(DatetimePicker);
Vue.use(Calendar);
Vue.use(Switch);
Vue.use(CheckboxGroup);
Vue.use(Checkbox);
Vue.use(RadioGroup);
Vue.use(Radio);
// 加入

const BASIC_URL = "//match.pai2345.com";
Vue.prototype.urlsite = BASIC_URL;
// axios
import axios from "axios";
Vue.prototype.axios = axios;
// axios代理设置
if (location.href.indexOf("match.frontend.pai2345.com") !== -1) {
  // 本地开发
  // axios.defaults.baseURL = "/match";
} else {
  // http协议时
  axios.defaults.baseURL = BASIC_URL + "/matchweb";
}

if (process.env.NODE_ENV === "production") {
  Vue.prototype.local = "prod";
} else {
  Vue.prototype.local = "dev";
}

// 公共变量
import tools from "./utils/common";
Vue.prototype.tools = tools;

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
